import React from "react";
import { useContext, useRef } from "react";
import { useAnimation } from "/context/AnimationProvider";
import useAxiosREST from "/utils/hooks/useAxiosAPI";
import AuthContext from "/context/AuthProvider";
import state from "/redux/state";

export default function Timer({ playButton = true }) {
  // 1) Забираємо isEnded з контексту
  const { timerData } = useAnimation();
  const { fetchAPI } = useAxiosREST();
  const { auth } = useContext(AuthContext);
  const generatedLink = useRef(null);
  const { timer, title, isEnded } = timerData ?? {};

  // 2) Обробник кліку для кнопки
  // const playNow = () => {
  //   const url =
  //     "https://funtico.com/games/golazo-league/compete-2-win/tournaments?autoplay=1&autoplay_type=tournament&autoplay_id=9fdc4f74-2831-4c4f-958e-422ebb615017";
  //   if (typeof window !== "undefined") {
  //     window.open(url, "_blank", "noopener,noreferrer");
  //   }
  // };

  const getTournament = async () => {
    if (!auth?.token) {
      state.setPopUp("login");
      return;
    }
    let link = generatedLink.current;

    if (!link) {
      const gameId = 182; // tournament.gameId;
      const data = await fetchAPI.post("/generate-game-link", { gameId });
      link = data.link;
    }
    if (link) {
      generatedLink.current = link;
      window.open(
        link +
          "&autoplay=1&autoplay_type=tournament&autoplay_id=9fdc4f74-2831-4c4f-958e-422ebb615017",
        "_blank"
      );
    }
  };

  // 3) Після завершення — показуємо кнопку

  // return (
  //   <div>
  //     <div className="event-timer">
  //       <button
  //         type="button"
  //         className="def cta-play pr type-40 br-16"
  //         onClick={getTournament}
  //         aria-label="Play now"
  //       >
  //         PLAY NOW
  //       </button>
  //     </div>
  //   </div>
  // );

  // 4) Інакше — звичний таймер
  return (
    <>
      {!isEnded && (
        <div className="event-timer">
          <p className="timer-title kanit-bold text-center">{title}</p>
          <div className="timer df ai-c">
            {Object.entries(timer ?? {}).map(([name, time], id) => (
              <React.Fragment key={name}>
                {id > 0 && <span className="sep digital-numbers">:</span>}
                <div className="col df fd-c ai-c">
                  <span className="t digital-numbers">{time}</span>
                  <span className="n kanit-bold">{name}</span>
                </div>
              </React.Fragment>
            ))}
          </div>
        </div>
      )}
      {playButton && (
        <div className="event-play">
          <button
            type="button"
            className="def cta-play pr type-40 br-16"
            onClick={getTournament}
            aria-label="Play now"
          >
            PLAY NOW
          </button>
        </div>
      )}
    </>
  );
}
